import React from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import EposNowTable from "components/eposnow/EposNowTable";

const EposNow = props => {
  return (
    <UserWrapper {...props}>
      <PageTitle
        title="sidebar.eposnowMappings"
        className="plr-15"
        breadCrumb={[
          { name: "sidebar.dashboard" },
          { name: "sidebar.eposnow" },
          { name: "sidebar.eposnowMappings" }
        ]}
      />
      <div className="user-tbl">
        <EposNowTable {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(EposNow);

